"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_NEW_KLASS_HIDDEN_MENUS = exports.DEFAULT_KLASS_MENU = exports.STUDENT_MENU_LIST = exports.TEACHER_MENU_LIST = exports.COMMON_MENU_LIST = exports.KLASS_MENU_LIST = void 0;
exports.KLASS_MENU_LIST = [
    {
        id: 'assignment',
        value: '과제',
    },
    {
        id: 'test',
        value: '테스트',
    },
    {
        id: 'attendanceStatus',
        value: '학생별 현황',
    },
    {
        id: 'sendSMS',
        value: 'SMS',
    },
    {
        id: 'gradeCard',
        value: '리포트',
    },
    {
        id: 'notice',
        value: '공지사항',
    },
    {
        id: 'qna',
        value: 'Q&A',
    },
    {
        id: 'resource',
        value: '학습자료',
    },
    {
        id: 'survey',
        value: '설문조사',
    },
    {
        id: 'reservation',
        value: '강의 예약',
    },
    {
        id: 'previous-conference',
        value: '지난 강의',
    },
    {
        id: 'replay-student',
        value: '다시보기',
    },
    {
        id: 'replay-teacher',
        value: '다시보기',
    },
    {
        id: 'content',
        value: '콘텐츠 관리',
    },
];
exports.COMMON_MENU_LIST = [
    {
        id: 'test',
        value: '테스트',
    },
    {
        id: 'assignment',
        value: '과제',
    },
    {
        id: 'notice',
        value: '공지사항',
    },
    {
        id: 'qna',
        value: 'Q&A 게시판',
    },
    {
        id: 'resource',
        value: '학습자료',
    },
    {
        id: 'survey',
        value: '설문조사',
    },
    {
        id: 'reservation',
        value: '강의 예약',
    },
];
exports.TEACHER_MENU_LIST = [
    {
        id: 'attendanceStatus',
        value: '학생별 현황',
    },
    {
        id: 'sendSMS',
        value: 'SMS',
    },
    {
        id: 'previous-conference',
        value: '지난 강의',
    },
    {
        id: 'content',
        value: '콘텐츠 관리',
    },
    {
        id: 'replay-teacher',
        value: '다시보기',
    },
];
exports.STUDENT_MENU_LIST = [
    {
        id: 'gradeCard',
        value: '리포트',
    },
    {
        id: 'replay-student',
        value: '다시보기',
    },
];
exports.DEFAULT_KLASS_MENU = [
    'assignment',
    'test',
    'attendanceStatus',
    'gradeCard',
    'notice',
    'qna',
    'resource',
    'survey',
    'sendSMS',
    'content',
    'reservation',
    'previous-conference',
    'replay-teacher',
    'replay-student',
];
/**
 * 신규 클래스 생성 시 기본으로 '비노출(체크 해제)' 상태로 둘 메뉴.
 *
 * 다시보기(학생)는 클래스를 만들었다는 사실만으로 학생 화면에 노출되면 안 된다는
 * 운영 요청(2026-09-17)에 따라 기본 숨김이다. 노출이 필요한 클래스만 관리자가
 * [메뉴 관리 > 학생 > 다시보기] 를 직접 체크해서 켠다.
 *
 * 강사용 다시보기(replay-teacher)는 강사가 다시보기를 준비·관리하는 화면이라
 * 기본 노출을 유지한다(학생 노출과 무관).
 *
 * 기존 클래스에는 영향이 없다 — 수정 화면은 서버가 준 hidden_menus 를 그대로 쓴다.
 */
exports.DEFAULT_NEW_KLASS_HIDDEN_MENUS = ['replay-student'];
